import { Box } from "@mui/material";

export { DealGridSkeleton } from "./skeleton";

const GRID_COLUMNS = {
  xs: "1fr",
  sm: "repeat(2, 1fr)",
  md: "repeat(3, 1fr)",
  lg: "repeat(4, 1fr)",
};

export function BaseGrid({ children, columns = GRID_COLUMNS }) {
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: columns,
        gap: 2,
        width: "100%",
        alignItems: "start",
      }}
    >
      {children}
    </Box>
  );
}